import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-primary py-12 md:py-16 border-t border-white/5 text-white/70">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row justify-between items-center gap-10 md:gap-4 mb-12">
          {/* Left: Copyright */}
          <div className="text-center md:text-left text-white/30 order-3 md:order-1 text-[0.65rem] md:text-xs tracking-widest uppercase font-semibold">
            &copy; {new Date().getFullYear()} South Haven Ride Share • Chris Burrows
          </div>

          {/* Center: Slogan */}
          <div className="flex items-center gap-4 text-accent/90 order-1 md:order-2 bg-white/5 px-8 py-4 rounded-full border border-white/10 text-[0.65rem] md:text-xs tracking-[0.2em] uppercase font-bold">
            <span>No Salt</span>
            <span className="w-1 h-1 bg-white/20 rounded-full hidden sm:block"></span>
            <span>No Sharks</span>
            <span className="w-1 h-1 bg-white/20 rounded-full hidden sm:block"></span>
            <span>No Worries</span>
          </div>

          {/* Right: Phone */}
          <div className="text-center md:text-right order-2 md:order-3">
            <a 
              href="tel:2699106622" 
              className="text-white hover:text-accent transition-all duration-300 font-bold border-b border-accent/30 pb-1 text-base md:text-lg tracking-widest"
            >
              269-910-6622
            </a>
          </div>
        </div>

        {/* SEO Footer Text */}
        <div className="pt-8 border-t border-white/5 text-center">
          <p className="text-[0.65rem] md:text-[0.7rem] font-serif italic text-white/20 max-w-2xl mx-auto leading-loose">
            Serving South Haven, MI and nearby Lake Michigan communities including Glenn, Saugatuck, and Covert. Premier transportation for bachelorette parties, winery rides, and beach-side hotels.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;